const firebaseConfig1 = {
  apiKey: process.env.REACT_APP_FIREBASE1_apiKey,
  authDomain: process.env.REACT_APP_FIREBASE1_authDomain,
  databaseURL: process.env.REACT_APP_FIREBASE1_databaseURL,
  projectId: process.env.REACT_APP_FIREBASE1_projectId,
  storageBucket: process.env.REACT_APP_FIREBASE1_storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE1_messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE1_appId
};

const firebaseConfig2 = {
  apiKey: process.env.REACT_APP_FIREBASE2_apiKey,
  authDomain: process.env.REACT_APP_FIREBASE2_authDomain,
  databaseURL: process.env.REACT_APP_FIREBASE2_databaseURL,
  projectId: process.env.REACT_APP_FIREBASE2_projectId,
  storageBucket: process.env.REACT_APP_FIREBASE2_storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE2_messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE2_appId
};

export { firebaseConfig1, firebaseConfig2 };
